import { render, staticRenderFns } from "./GoodsCoupons.vue?vue&type=template&id=59c8af3f&scoped=true"
import script from "./GoodsCoupons.vue?vue&type=script&lang=js"
export * from "./GoodsCoupons.vue?vue&type=script&lang=js"
import style0 from "./GoodsCoupons.vue?vue&type=style&index=0&id=59c8af3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8af3f",
  null
  
)

export default component.exports